import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import {
  FeedbackReportDraft,
  FeedbackReportReceipt,
} from '../../domain/models/feedback-report.model';
import { IFeedbackReportRepository } from '../../domain/repositories/feedback-report.repository';
import { FeedbackReportRemoteDatasource } from '../datasources/remote/feedback-report.remote-datasource';
import { FeedbackReportMapper } from '../mappers/feedback-report.mapper';

@Injectable()
export class FeedbackReportRepositoryImpl implements IFeedbackReportRepository {
  private readonly datasource = inject(FeedbackReportRemoteDatasource);
  private readonly mapper = inject(FeedbackReportMapper);

  public submit(draft: FeedbackReportDraft): Observable<FeedbackReportReceipt> {
    return this.datasource.submit(draft).pipe(map((dto) => this.mapper.toDomain(dto)));
  }
}
